import React, { useEffect, useState } from "react";
import { LuUsers } from "react-icons/lu";
import { FaLinkSlash } from "react-icons/fa6";
import { IoIosArrowRoundUp, IoIosArrowRoundDown } from "react-icons/io";
import { Box, Text } from "@chakra-ui/react";
import "./Info.css";

const InfoCards = ({ totalUsers, totalLinks, apiLink, axios }) => {
  const [userLogs, setUserLogs] = useState({});
  const [linksLogs, setLinksLogs] = useState({});

  function logProgress(percentage) {
    const integerPart = Math.floor(percentage);
    if (percentage < 0) return Math.min(integerPart * -1, 100);
    return Math.min(integerPart, 100);
  }

  //   User logs
  useEffect(() => {
    const fetchUserLogs = async () => {
      try {
        const data = await axios.get(`${apiLink}shorten/getuserlogs`);
        setUserLogs(data?.data);
      } catch (error) {
        console.error("Error fetching logs", error);
      }
    };
    fetchUserLogs();
  }, [apiLink]);

  //   Links logs
  useEffect(() => {
    const fetchLinksLogs = async () => {
      try {
        const data = await axios.get(`${apiLink}shorten/getlinkslogs`);
        setLinksLogs(data?.data);
      } catch (error) {
        console.error("Error fetching logs", error);
      }
    };
    fetchLinksLogs();
  }, [apiLink]);

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "stretch",
        // justifyContent: "center",
        gap: "25px",
      }}
    >
      {/* Links logs */}
      <Box
        sx={{
          width: "284px",
          padding: "16px",
          borderRadius: "8px",
          boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
          background: "#fff",
          transition: "all 0.3s ease-in-out",
          "&:hover": {
            boxShadow: "0 4px 12px rgba(0, 0, 0, 0.2)",
            transform: "translateY(-5px)",
          },
        }}
      >
        <div className="card-content">
          <div className="first-line">
            <p style={{ color: "#6a778b", fontWeight: 500 }}>
              {" "}
              Total Links Created Today
            </p>{" "}
            <FaLinkSlash color="#6231f7" size={18} />
          </div>

          <div className="second-line-parent">
            <div className="second-line">
              <Text sx={{ fontWeight: 500, fontSize: "20px" }}>
                {" "}
                {linksLogs?.countToday}{" "}
              </Text>

              {linksLogs?.percentageChange < 0 ? (
                <small className="decrease">
                  {" "}
                  <IoIosArrowRoundDown />
                  {linksLogs?.percentageChange * -1}%
                </small>
              ) : (
                <small className="increase">
                  <IoIosArrowRoundUp />
                  {linksLogs?.percentageChange}%
                </small>
              )}
            </div>

            <small className="prev">vs. previous day</small>
          </div>

          <div className="first-line">
            <small>0%</small>
            <small>100%</small>
          </div>
          <div
            className="progress-bar"
            style={{
              backgroundColor:
                linksLogs?.percentageChange < 0 ? "#ffe4e4" : "#e4faff",
            }}
          >
            <div
              className="progress"
              style={{
                width: `${logProgress(linksLogs?.percentageChange)}%`,
                backgroundColor:
                  linksLogs?.percentageChange < 0 ? "#aa3939" : "#378ba3",
              }}
            ></div>
          </div>
        </div>
      </Box>

      {/* New users logs */}
      <Box
        sx={{
          width: "284px",
          padding: "16px",
          borderRadius: "8px",
          boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
          background: "#fff",
          transition: "all 0.3s ease-in-out",
          "&:hover": {
            boxShadow: "0 4px 12px rgba(0, 0, 0, 0.2)",
            transform: "translateY(-5px)",
          },
        }}
      >
        <div className="card-content">
          {" "}
          <div className="first-line">
            {" "}
            <p style={{ color: "#6a778b", fontWeight: 500 }}>
              New Clients
            </p>{" "}
            <LuUsers color="#6231f7" size={18} />
          </div>{" "}
          <div className="second-line-parent">
            {" "}
            <div className="second-line">
              {" "}
              <Text sx={{ fontWeight: 500, fontSize: "20px" }}>
                {userLogs?.countToday}
              </Text>
              {userLogs?.percentageChange < 0 ? (
                <small className="decrease">
                  {" "}
                  <IoIosArrowRoundDown /> {userLogs?.percentageChange *
                    -1}%{" "}
                </small>
              ) : (
                <small className="increase">
                  {" "}
                  <IoIosArrowRoundUp /> {userLogs?.percentageChange}%{" "}
                </small>
              )}{" "}
            </div>{" "}
            <small className="prev">vs. previous day</small>{" "}
          </div>{" "}
          <div className="first-line">
            {" "}
            <small>0%</small> <small>100%</small>{" "}
          </div>{" "}
          <div
            className="progress-bar"
            style={{
              backgroundColor:
                userLogs?.percentageChange < 0 ? "#ffe4e4" : "#e4faff",
            }}
          >
            {" "}
            <div
              className="progress"
              style={{
                width: `${logProgress(userLogs?.percentageChange)}%`,
                backgroundColor:
                  userLogs?.percentageChange < 0 ? "#aa3939" : "#378ba3",
              }}
            ></div>{" "}
          </div>{" "}
        </div>
      </Box>

      {/* Total users count */}
      <Box
        sx={{
          width: "284px",
          padding: "16px",
          borderRadius: "8px",
          boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
          background: "#fff",
          transition: "all 0.3s ease-in-out",
          "&:hover": {
            boxShadow: "0 4px 12px rgba(0, 0, 0, 0.2)",
            transform: "translateY(-5px)",
          },
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <p style={{ color: "#6a778b", fontWeight: 500 }}>Total Clients</p>
          <LuUsers color="#6231f7" size={18} />
        </Box>
        <Text sx={{ mt: 2, fontWeight: 500, fontSize: "20px" }}>
          {totalUsers || 0}
        </Text>
      </Box>

      {/* Total links count */}
      <Box
        sx={{
          width: "284px",
          padding: "16px",
          borderRadius: "8px",
          boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
          background: "#fff",
          transition: "all 0.3s ease-in-out",
          "&:hover": {
            boxShadow: "0 4px 12px rgba(0, 0, 0, 0.2)",
            transform: "translateY(-5px)",
          },
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <p style={{ color: "#6a778b", fontWeight: 500 }}>
            Total Links Created
          </p>
          <FaLinkSlash color="#6231f7" size={18} />
        </Box>
        <Text sx={{ mt: 2, fontWeight: 500, fontSize: "20px" }}>
          {totalLinks}
        </Text>
      </Box>
    </Box>
  );
};

export default InfoCards;
